import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import { confirmClaimModalStyles as styles } from './confirmClaimModal.tailwind';
import Button from '../../Button/Button';
import CloseIcon from '@mui/icons-material/Close';
import redeem_rewards from '../../../../assets/svgs/redeem_reward.svg';

const confirmClaimModal = ({ isOpen, onClose, onClaim, reward }) => {
    const { claimingReward } = useSelector(state => state.reward);

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableAutoFocus
        >
            <div className={styles.container}>
                <div className={styles.closeIconContainer} onClick={onClose}>
                    <CloseIcon sx={{ fontSize: '16px' }} />
                </div>
                {/* <img src={reward?.rewardIcon} alt='icon' /> */}
                <div className={styles.popupheading}>
                    <img src={redeem_rewards} alt="redeem_rewards" className={styles.redeem_rewards}></img>              
                    <div className={styles.heading}>Redeem Rewards</div>
                </div>
                <div className={styles.description}>Are you sure you want redeem <span className={styles.highlightedText}>{reward?.rewardTitle}</span> for <span className={styles.highlightedText}>{reward?.pointsValue}</span> points ?</div>
                <div className={styles.buttonContainer}>
                    <Button variant="theme" className={styles.button} onClick={onClaim} disabled={claimingReward}>
                        {claimingReward ? `Redeeming...` : `Redeem`}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default confirmClaimModal